import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/complaint-book/index.js");
